<template>
  <div class="giftcard-steps">
    <div class="giftcard-steps__list">
      <component
        :is="getElement(currentStep > step.number)"
        v-for="(step, key) in steps"
        :key="key"
        :class="{
          'giftcard-steps__item--done': currentStep > step.number,
          'giftcard-steps__item--active': currentStep === step.number,
          'giftcard-steps__item--todo': currentStep < step.number,
        }"
        :to="step.path"
        class="giftcard-steps__item"
      >
        <span
          class="giftcard__label"
          v-text="step.label"
        />
      </component>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  AppLink,
} from '#components'

const { t } = useI18n({ useScope: 'global' })

const currentStep = inject('step', 1)

const steps = ref([
  { number: 1, label: t('Gitcard'), path: '/' },
  { number: 2, label: t('Details'), path: '/customer' },
  { number: 3, label: t('Payment'), path: '/payment' },
])

const getElement = (active: boolean) => {
  return active ? AppLink : 'div'
}
</script>

<style src="~layers/app/components/Giftcard/Steps.css" />
